import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Box, Typography, IconButton, Grid, Chip } from '@mui/material';
import { FiPlus, FiX } from 'react-icons/fi';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate } from 'react-router-dom';
import { getSession } from '../../../../getSession';
import { getActivityMasters, getActivityDetailById, removeCustomEvent, saveActivityMaster, updateActivityStatus } from '../../../../utils/lead';
import SubHeader from '../../../../components/common/SubHeader/SubHeader';
import CreateEventForm from './CreateEventForm';
import Swal from 'sweetalert2';
import PremiumModuleWrapper from '../../../Task/Components/common/PremiumModuleWrapper';
import PremiumModuleCards from '../../../Task/Components/common/PremiumModuleCards';
import GridMainPanelLayout from '../../../../components/common/Panels/GridMainPanelLayout';
import { Icon } from '@iconify/react';
import { useModulePermissions } from '../../../../hooks/useModulePermissions';

const CreateEventWrapper = () => {
    const tableRef = useRef(null);
    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [viewMode, setViewMode] = useState('table');
    const [stats, setStats] = useState({ total: 0, active: 0, inactive: 0, predefined: 0 });
    const [tableData, setTableData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 100;
    const searchRef = useRef('');
    const navigate = useNavigate();
    const { userId, TokenId, parentId } = getSession();

    // ── Module Permissions (PAG10333 = Custom Event) ─────────────────────────
    const { canAdd, canEdit, canDelete, canSearch, canView, PermissionDeniedComponent } = useModulePermissions('PAG10333');

    useEffect(() => {
        searchRef.current = searchTerm;
    }, [searchTerm]);

    const fetchEvents = useCallback(async (start = 0, length = 100) => {
        try {
            const payload = {
                UserId: userId,
                token: TokenId,
                FilterText: searchRef.current,
                draw: 1,
                start: start,
                length: length
            };
            const response = await getActivityMasters(payload);

            let result = response.d || response;
            if (typeof result === 'string') {
                try { result = JSON.parse(result); } catch (e) { }
            }

            const tableRecords = result.data || [];
            setTableData(tableRecords);

            if (result.recordsTotal !== undefined) {
                setRecordsTotal(result.recordsTotal);

                const isTrue = (val) => val === true || val === 1 || val === '1' || String(val).toLowerCase() === 'true';

                const activeCount = result.activeRecords || result.ActiveCount || tableRecords.filter(r => isTrue(r.IsActive)).length;
                const inactiveCount = result.inactiveRecords || result.InactiveCount || tableRecords.filter(r => !isTrue(r.IsActive)).length;
                const predefinedCount = result.predefinedRecords || result.PredefinedCount || tableRecords.filter(r => isTrue(r.IsPredefind)).length;

                setStats({
                    total: result.recordsTotal || 0,
                    active: activeCount,
                    inactive: inactiveCount,
                    predefined: predefinedCount
                });
            }
            return result;
        } catch (error) {
            console.error('Error fetching events:', error);
            throw error;
        }
    }, [userId, TokenId]);

    useEffect(() => {
        if (viewMode === 'grid') {
            fetchEvents((currentPage - 1) * itemsPerPage, itemsPerPage);
        }
    }, [viewMode, currentPage, itemsPerPage, fetchEvents]);

    useEffect(() => {
        if (viewMode !== 'table') return;

        const initEventTable = () => {
            if ($.fn.DataTable.isDataTable('#tblEventList')) {
                $('#tblEventList').DataTable().destroy();
            }

            const eventTable = $('#tblEventList').DataTable({
                "dom": "tr" + "p",
                "stripeClasses": ["datatable__row", "datatable__row"],
                "paging": true,
                "pageLength": 100,
                "processing": true,
                "serverSide": false,
                "ajax": function (data, callback, settings) {
                    fetchEvents(0, 1000).then(function (result) {
                        callback({
                            data: result.data || []
                        });
                    }).catch(function (error) {
                        console.error('DataTables Ajax error:', error);
                        callback({
                            data: []
                        });
                    });
                },
                "language": {
                    "info": "_START_ to _END_ of _TOTAL_ entries",
                    "infoEmpty": "0 to 0 of 0 entries",
                    "sEmptyTable": `<div class="no-record"><img src="/assets/nodata.gif" style="width:200px"/><span>No record Found. </span> <a href="javascript:void(0)" id="btnAddNewEvent"><span class="no-text">Click here to add your Event now</span><i class="fa fa-plus-square-o"></i></a></div>`
                },
                "columns": [
                    {
                        "data": "EventName",
                        "title": `Name`,
                        "defaultContent": "",
                        "render": (data) => `<span class="fl text-overflow">${data || ''}</span>`
                    },
                    {
                        "data": "EventTemplate",
                        "title": `Description`,
                        "defaultContent": "",
                        "render": (data) => `<p class="text-overflow">${data || ''}</p>`
                    },
                    {
                        "data": null,
                        "title": `Trigger Count`,
                        "orderable": false,
                        "bSortable": false,
                        "render": (data) => `
                            <a href="javascript:void(0);" class="btnShowTriggerHistory" data-id="${data.Id}">${(data.SuccessCount || 0) + (data.FailCount || 0)}</a>
                            <div class="progress" style="height: 12px; margin-top: 5px; position: relative;">
                                <div class="progress-bar bg-danger" role="progressbar" style="width: 45%;"></div>
                                <span style="position:absolute; left:5px; font-size:10px; color: #fff;">${data.SuccessCount || 0}</span>
                                <span style="position:absolute; right:5px; font-size:10px; color: #666;">${data.FailCount || 0}</span>
                            </div>`
                    },
                    {
                        "data": null,
                        "title": `Event Detail`,
                        "orderable": false,
                        "bSortable": false,
                        "render": (data) => `
                            <div>
                                <p style="margin:0"><strong>Date</strong> ${data.CreatedOn || ''}</p>
                                <p style="margin:0"><strong>CreatedBy</strong> ${data.CreatedBy || ''}</p>
                            </div>`
                    },
                    {
                        "data": "IsActive",
                        "title": `Is Active`,
                        "orderable": false,
                        "bSortable": false,
                        "render": (data, type, row) => `
                            <div class="form-check form-switch custom-switch-green">
                                <input class="form-check-input chkIsActive" type="checkbox" ${row.IsPredefind ? 'disabled' : ''} ${data ? 'checked' : ''} data-id="${row.Id}" style="cursor: pointer;">
                            </div>`
                    },
                    {
                        "data": null,
                        "title": `Action`,
                        "orderable": false,
                        "bSortable": false,
                        "render": (data) => `
                            <div class="dropdown text-center position-relative d-inline-block">
                                <button class="btn btn-sm action-dot-btn" type="button">
                                    <i class="bi bi-three-dots"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end premium-dropdown">
                                    <li>
                                        <a class="dropdown-item btnView" data-id="${data.Id}" href="#">
                                            <i class="bi bi-eye"></i> View
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item btnWebhookPayload" data-id="${data.Id}" href="#">
                                            <i class="bi bi-eye"></i> Webhook Payload
                                        </a>
                                    </li>
                                    ${canEdit ? `<li><a class="dropdown-item btnEdit" data-id="${data.Id}" href="#"><i class="bi bi-pencil"></i> Edit</a></li>` : ''}
                                    ${canDelete ? `<li><hr class="dropdown-divider"></li><li><a class="dropdown-item btnRemove text-danger" data-id="${data.Id}" href="#"><i class="bi bi-trash"></i> Remove</a></li>` : ''}
                                </ul>
                            </div>`
                    }
                ]
            });

            // Add styles for the premium dropdown and switch
            if (!$('#custom-event-styles').length) {
                $('head').append(`
                    <style id="custom-event-styles">
                        .action-dot-btn {
                            border: none;
                            background: transparent;
                            color: #64748b;
                            font-size: 1.2rem;
                            padding: 2px 8px;
                            transition: all 0.2s;
                            cursor: pointer;
                        }
                        .action-dot-btn:hover {
                            color: #334155;
                            background-color: #f1f5f9;
                            border-radius: 4px;
                        }
                        .premium-dropdown {
                            display: none;
                            position: absolute;
                            top: 0;
                            right: 100%; /* Align right edge of menu to left edge of container */
                            margin-right: 5px;
                            z-index: 1060;
                            border-radius: 12px;
                            padding: 8px;
                            min-width: 180px;
                            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
                            border: 1px solid #e2e8f0 !important;
                            background: white;
                        }
                        .premium-dropdown.show {
                            display: block;
                        }
                        .premium-dropdown .dropdown-item {
                            border-radius: 8px;
                            padding: 8px 12px;
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            font-size: 14px;
                            color: #475569;
                        }
                        .premium-dropdown .dropdown-item i {
                            font-size: 16px;
                            width: 18px;
                            text-align: center;
                        }
                        .premium-dropdown .dropdown-item:hover {
                            background-color: #f8fafc;
                            color: #1e293b;
                        }
                        .custom-switch-green .form-check-input:checked {
                            background-color: #28c76f;
                            border-color: #28c76f;
                        }
                        /* Ensure table container allows dropdown to show */
                        #tblEventList_wrapper {
                            overflow: visible !important;
                        }
                        .dataTables_scrollBody {
                            overflow: visible !important;
                        }
                    </style>
                `);
            }

            // Handle "Add New Event" click in empty table
            $(document).off('click', '#btnAddNewEvent').on('click', '#btnAddNewEvent', () => handlerAddEditCustomEvent({}));

            // Handle Action Dropdown Toggle
            $('#tblEventList').off('click', '.action-dot-btn').on('click', '.action-dot-btn', function (e) {
                e.stopPropagation();
                const $menu = $(this).next('.premium-dropdown');
                $('.premium-dropdown').not($menu).removeClass('show');
                $menu.toggleClass('show');
            });

            // Close menu on click outside or item click
            $(document).off('click.closeActionMenu').on('click.closeActionMenu', function (e) {
                if (!$(e.target).closest('.dropdown').length) {
                    $('.premium-dropdown').removeClass('show');
                }
            });

            $('#tblEventList').on('click', '.premium-dropdown .dropdown-item', function () {
                $('.premium-dropdown').removeClass('show');
            });

            // Bind Actions
            $('#tblEventList').off('click', '.chkIsActive').on('click', '.chkIsActive', function () {
                const id = $(this).data('id');
                const status = $(this).is(':checked');
                updateStatus(id, status);
            });

            $('#tblEventList').off('click', '.btnEdit').on('click', '.btnEdit', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                handleEditEvent(id);
            });

            $('#tblEventList').off('click', '.btnRemove').on('click', '.btnRemove', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        deleteEvent(id);
                    }
                });
            });

            $('#tblEventList').off('click', '.btnView').on('click', '.btnView', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                handleViewEventDetail(id);
            });

            $('#tblEventList').off('click', '.btnWebhookPayload').on('click', '.btnWebhookPayload', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                handleShowWebPayload(id);
            });

            $('#tblEventList').off('click', '.btnShowTriggerHistory').on('click', '.btnShowTriggerHistory', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                navigate('/custom-events/webhook', { state: { ActivityId: id } });
            });
        };

        initEventTable();

        return () => {
            if ($.fn.DataTable.isDataTable('#tblEventList')) {
                $('#tblEventList').DataTable().destroy();
            }
        };
    }, [userId, TokenId, navigate, viewMode, canEdit, canDelete]);

    const updateStatus = async (id, status) => {
        try {
            const payload = {
                Token: TokenId,
                Details: {
                    EventId: id,
                    UserId: userId,
                    Status: status
                }
            };
            const response = await updateActivityStatus(payload);
            const result = response.d || response;

            if (result && result.Status === 1) {
                Swal.fire('Success', 'Status updated successfully', 'success');
                $('#tblEventList').DataTable().ajax.reload(null, false);
            } else {
                Swal.fire('OOPs...', result?.Message || 'Unable to update status', 'warning');
                // Revert checkbox state if needed (DataTable reload will do it anyway)
                $('#tblEventList').DataTable().ajax.reload(null, false);
            }
        } catch (e) {
            console.error('updateStatus error:', e);
            Swal.fire('Error', 'Failed to update status', 'error');
            $('#tblEventList').DataTable().ajax.reload(null, false);
        }
    };

    const deleteEvent = async (id) => {
        try {
            const response = await removeCustomEvent({
                Token: TokenId,
                Details: {
                    EventId: id,
                    UserId: userId,
                    Status: true
                }
            });
            if (response && response.Status === 1) {
                Swal.fire('Deleted!', 'Event has been deleted.', 'success');
                $('#tblEventList').DataTable().ajax.reload(null, false);
            } else {
                Swal.fire('OOPs...', response?.Message || 'Unable to delete event', 'warning');
            }
        } catch (e) {
            Swal.fire('Error', 'Failed to delete event', 'error');
        }
    };

    const handleViewEventDetail = async (eventId) => {
        let eventData = await getEventDetail(eventId);
        if (!eventData) {
            Swal.fire('OOPs...', 'Please click on valid event', 'warning');
            return;
        }

        let uiSetting = {};
        try { uiSetting = JSON.parse(eventData.UiSettingJSON); } catch (e) { }

        let $webhookProperty = $('<div/>', { class: `container-fluid px-0 text-start` });
        let $wpHeader = $('<div/>', { class: `row mb-2 border-bottom pb-1 mx-0` })
            .append($('<div/>', { class: `col-md-2 px-1` }).append($('<p/>', { class: `font14 font-weight-bolder mb-0`, style: `color: #000;`, text: `KeyName` })))
            .append($('<div/>', { class: `col-md-3 px-1` }).append($('<p/>', { class: `font14 font-weight-bolder mb-0`, style: `color: #000;`, text: `Display Name` })))
            .append($('<div/>', { class: `col-md-1 px-1` }).append($('<p/>', { class: `font14 font-weight-bolder mb-0`, style: `line-height: 1.1; color: #000;`, html: `Data<br/>type` })))
            .append($('<div/>', { class: `col-md-2 px-1` }).append($('<p/>', { class: `font14 font-weight-bolder mb-0`, style: `color: #000;`, text: `Is Required` })))
            .append($('<div/>', { class: `col-md-4 px-1` }).append($('<p/>', { class: `font14 font-weight-bolder mb-0`, style: `color: #000;`, text: `Default Value` })));

        $webhookProperty.append($wpHeader);
        let webhookPayload = {};
        if (uiSetting && typeof (uiSetting.WebhookProperty) === 'object') {
            uiSetting.WebhookProperty.forEach((w) => {
                webhookPayload[w.KeyName] = w.DefaultValue;
                let $wpBodyRow = $('<div/>', { class: `row mb-1 mx-0` })
                    .append($('<div/>', { class: `col-md-2 px-1` }).append($('<p/>', { class: `font13 font-weight-normal mb-0 text-break`, text: `${w.KeyName}` })))
                    .append($('<div/>', { class: `col-md-3 px-1` }).append($('<p/>', { class: `font13 font-weight-normal mb-0 text-break`, text: `${w.DisplayName}` })))
                    .append($('<div/>', { class: `col-md-1 px-1` }).append($('<p/>', { class: `font13 font-weight-normal mb-0`, text: `${w.DataType}` })))
                    .append($('<div/>', { class: `col-md-2 px-1` }).append($('<p/>', { class: `font13 font-weight-normal mb-0`, text: `${w.IsRequired}` })))
                    .append($('<div/>', { class: `col-md-4 px-1` }).append($('<p/>', { class: `font13 font-weight-normal mb-0 text-break`, text: `${w.DefaultValue}` })));
                $webhookProperty.append($wpBodyRow);
            });
        }

        let $mainContainer = $('<div/>', { class: `container-fluid px-4 py-3 text-start`, style: `text-align: left !important;` });
        $mainContainer
            .append($('<div/>', { class: `row mb-4` })
                .append($('<div/>', { class: `col-md-3` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Name` })).append($('<p/>', { class: `font13 mb-0 text-break`, text: `${eventData.EventName}` })))
                .append($('<div/>', { class: `col-md-2` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Event Entity` })).append($('<p/>', { class: `font13 mb-0`, text: `${eventData.EventType || eventData.Context}` })))
                .append($('<div/>', { class: `col-md-2` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Trigger Count` })).append($('<p/>', { class: `font13 mb-0`, text: `${(eventData.SuccessCount || 0) + (eventData.FailCount || 0)}` })))
                .append($('<div/>', { class: `col-md-5 px-0` })
                    .append($('<div/>', { class: `row mx-0` })
                        .append($('<div/>', { class: `col-md-7 px-1` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Event Detail` })).append($('<p/>', { class: `font13 mb-0` }).append($('<span/>', { class: `font-weight-bolder`, style: `color: #000;`, text: `Date: ` })).append($('<span/>', { text: `${eventData.CreatedOn}` }))))
                        .append($('<div/>', { class: `col-md-5 px-1` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, text: `\u00A0` })).append($('<p/>', { class: `font13 mb-0` }).append($('<span/>', { class: `font-weight-bolder`, style: `color: #000;`, text: `CreatedBy: ` })).append($('<span/>', { text: `${eventData.CreatedBy}` }))))
                    )
                )
            )
            .append($('<div/>', { class: `mb-4` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Event Description` })).append($('<p/>', { class: `font13 mb-0`, text: `${eventData.EventTemplate || 'No description'}` })))
            .append($('<div/>', { class: `mb-4` }).append($('<p/>', { class: `font13 font-weight-bolder mb-1`, style: `color: #000;`, text: `Webhook Payload` })).append($('<pre/>', { class: `bg-light p-3 border-0 font13`, style: `background: #f8f9fa; border-radius: 8px; text-align: left;`, text: JSON.stringify(webhookPayload, null, 4) })))
            .append($('<div/>', { class: `mb-4` }).append($('<p/>', { class: `font14 font-weight-bolder mb-2`, style: `color: #000;`, text: `Webhook Property Definition` })).append($webhookProperty));

        if (window.formControls && window.formControls.CustomModal) {
            let $modal = window.formControls.CustomModal();
            let configPayload = {
                BackText: 'Back to Event List',
                Heading: 'Event Details',
                Body: $mainContainer,
                Footer: '',
                Buttons: []
            };
            $modal.config(configPayload);
            $modal.show();
        } else {
            Swal.fire({
                title: `
                    <div class="text-start w-100 px-3 py-2" style="background: #f1f5f9; margin: 0; border-radius: 4px 4px 0 0; font-size: 16px; color: #475569; border-bottom: 1px solid #e2e8f0;">
                        <i class="ri-close-line float-start me-2"></i> Back to Event List
                    </div>
                    <div class="text-start w-100 px-3 pb-1 pt-3" style="font-size: 18px; font-weight: 700; color: #000;">Event Details</div>`,
                html: $mainContainer[0],
                width: '1100px',
                padding: '0',
                showConfirmButton: true,
                confirmButtonText: 'Cancel',
                confirmButtonColor: '#f8fafc',
                customClass: {
                    container: 'premium-swal-container',
                    popup: 'premium-swal-popup',
                    title: 'p-0 m-0',
                    confirmButton: 'btn btn-light text-dark border mb-4 px-4'
                }
            });
        }
    };

    const handleShowWebPayload = async (eventId) => {
        let eventData = await getEventDetail(eventId);
        if (!eventData) {
            Swal.fire('OOPs...', 'Please click on valid event', 'warning');
            return;
        }

        let strJSON = {};
        try { strJSON = JSON.parse(eventData.UiSettingJSON); } catch (e) { }

        let webPayload = {};
        if (strJSON && strJSON.WebhookProperty) {
            strJSON.WebhookProperty.forEach((w) => {
                webPayload[w.KeyName] = w.DefaultValue;
            });
        }
        if (strJSON && strJSON.HasProduct) {
            webPayload['HasProduct'] = true;
            webPayload['products'] = ["ProductName1", "ProductName2", "ProductName3"];
        }

        let $preText = $('<pre/>', { text: JSON.stringify(webPayload, null, '\t') });
        let $payloadContainer = $('<span/>', { class: `payloadCont` });
        let $btnClone = $('<span/>', {
            class: `copycont`,
            html: `<span>Payload</span><button type="click"><i class="fa fa-clone"></i></button>`,
            on: {
                click: function (e) {
                    e.preventDefault();
                    navigator.clipboard.writeText($preText.text());
                    Swal.fire('Copied', 'Payload copied to clipboard', 'success');
                }
            }
        });

        const Apiurl = window.Apiurl || '';
        let $urlText = $('<pre/>', { text: `${Apiurl}/CustomEvent/${parentId}/Webhooks` });
        let $urlContainer = $('<span/>', { class: `payloadCont` });
        let $btnUrlClone = $('<span/>', {
            class: `copycont`,
            html: `<span>Url with POST</span><button type="click"><i class="fa fa-clone"></i></button>`,
            on: {
                click: function (e) {
                    e.preventDefault();
                    navigator.clipboard.writeText($urlText.text());
                    Swal.fire('Copied', 'URL copied to clipboard', 'success');
                }
            }
        });

        $urlContainer.append($btnUrlClone).append($urlText);
        $payloadContainer.append($btnClone).append($preText);

        let $modalBody = $('<div/>', {}).append($urlContainer).append($payloadContainer);

        if (window.formControls && window.formControls.DomainModal) {
            let $modal = window.formControls.DomainModal();
            let modalPayload = {
                isCancel: true,
                heading: `Webhook Payload`,
                body: $modalBody,
                buttons: [],
            };
            $modal.config(modalPayload);
            $modal.show();
        } else {
            Swal.fire({
                title: 'Webhook Payload',
                html: $modalBody[0],
                width: '600px'
            });
        }
    };

    const handleEditEvent = async (eventId) => {
        let eventData = await getEventDetail(eventId);
        if (!eventData) {
            Swal.fire('OOPs...', 'Please click on valid event', 'warning');
            return;
        }

        let _event = {};
        try { _event = JSON.parse(eventData.UiSettingJSON); } catch (e) { }

        if (typeof (_event) === 'object') {
            _event.EventId = eventId;
            handlerAddEditCustomEvent(_event);
        }
    };

    const handlerAddEditCustomEvent = (options) => {
        const flowControls = window.flowControls || window.formControls;
        if (!flowControls || !flowControls.CustomModal) {
            setShowForm(true); // Fallback to React form
            return;
        }

        let $modal = flowControls.CustomModal();
        let _eventName = `Event_${new Date().getTime()}`;

        let _default = {
            EventId: 0,
            EventName: _eventName,
            EntityName: 'Lead',
            WebhookProperty: [
                {
                    KeyName: 'EventIdentifier', DisplayName: 'Event Identifier',
                    DataType: 'string', IsRequired: true, DefaultValue: `${_eventName}`, IsRemovable: true
                }, {
                    KeyName: 'EntityIdentifier', DisplayName: 'Entity Identifier',
                    DataType: 'string', IsRequired: true, DefaultValue: `MobileNo`, IsRemovable: true
                }, {
                    KeyName: 'MobileNo', DisplayName: 'MobileNo',
                    DataType: 'string', IsRequired: true, DefaultValue: `#MobileNo#`, IsRemovable: true
                }
            ],
            EventDescription: ``,
            ColumnMapping: {
                ActionName: 'failure',
                CreateAction: {
                    SourceName: { Id: 0, Name: '' },
                    PersonName: ``,
                    ColumnMapping: []
                }
            }
        };

        let _settingJSON = $.extend({}, _default, options);
        let afterChangeSave = (customEvent) => {
            _settingJSON = customEvent;
        }

        let $btnSave = $('<button/>', {
            class: `btn btn-primary pull-right`,
            text: `Save`,
            type: `button`,
            'data-EventId': `${_settingJSON.EventId}`,
            on: {
                click: function (e) {
                    e.preventDefault();
                    let afterAjax = () => {
                        $modal.hide();
                        $('#tblEventList').DataTable().ajax.reload(null, false);
                    };
                    validateSaveCustomEvent(_settingJSON, afterAjax);
                }
            }
        });

        if (window.customEventUiHandler) {
            let $body = window.customEventUiHandler(_settingJSON, afterChangeSave);
            let configPayload = {
                BackText: 'Back to Event List',
                Heading: 'Event Details',
                Body: $body,
                Footer: '',
                Buttons: [$btnSave]
            };
            $modal.config(configPayload);
            $modal.show();
        } else {
            setShowForm(true);
        }
    };

    const validateSaveCustomEvent = async (ce, callback) => {
        try {
            if (!ce.EventName) throw new Error('EventName is required');
            if (!/^[a-zA-Z0-9_ ]+$/.test(ce.EventName)) {
                throw new Error('Special characters are not allowed in Event Name');
            }
            if (!ce.EntityName) throw new Error('EntityName is required');
            if (!ce.EventDescription) throw new Error('EventDescription is required');

            let payload = {
                Token: TokenId,
                Details: {
                    EventId: ce.EventId,
                    EventName: ce.EventName,
                    EventTemplate: ce.EventDescription,
                    EventEntity: ce.EntityName,
                    ParentId: parentId,
                    UserId: userId,
                    LeadSettingJSON: JSON.stringify(ce.ColumnMapping),
                    UiSettingJSON: JSON.stringify(ce)
                }
            };

            const response = await saveActivityMaster(payload);
            const result = response.d || response;

            if (result && result.Status === 1) {
                const details = result.Details;
                let isSuccess = false;

                switch (details?.toLowerCase()) {
                    case 'inserted':
                    case 'updated':
                        isSuccess = true;
                        break;
                    case 'exists':
                        Swal.fire('OOPs...', 'Event Name already exists', 'warning');
                        break;
                    default:
                        // Handle other potential return strings from backend
                        if (details === '1' || details === 1) isSuccess = true;
                        break;
                }

                if (isSuccess) {
                    Swal.fire('Success', 'Data saved successfully', 'success');
                    if (typeof (callback) === 'function') callback();
                    $('#tblEventList').DataTable().ajax.reload(null, false);
                } else if (details?.toLowerCase() !== 'exists') {
                    Swal.fire('OOPs...', result.Message || 'Unable to save event', 'warning');
                }
            } else {
                Swal.fire('OOPs...', response?.Message || 'Unable to save event', 'warning');
            }
        } catch (e) {
            Swal.fire('OOPs...', e.message, 'warning');
        }
    };

    const getEventDetail = async (eventId) => {
        try {
            const response = await getActivityDetailById({
                Token: TokenId,
                Details: {
                    EventId: eventId,
                    UserId: userId
                }
            });
            return response.Details || response.d || response;
        } catch (error) {
            console.error('Error fetching event details:', error);
            return undefined;
        }
    };

    const handleSearch = () => {
        if ($.fn.DataTable.isDataTable('#tblEventList')) {
            $('#tblEventList').DataTable().ajax.reload();
        }
    };

    const handleRefresh = () => {
        setSearchTerm('');
        searchRef.current = '';
        handleSearch();
    };

    const handleShowAll = () => {
        setSearchTerm('');
        searchRef.current = '';
        if ($.fn.DataTable.isDataTable('#tblEventList')) {
            const table = $('#tblEventList').DataTable();
            table.search('').columns().search('').draw();
            table.ajax.reload();
        }
    };

    const customCards = [
        {
            title: stats.total || 0,
            subtitle: 'Total Events',
            icon: 'ri:calendar-event-line',
            color: 'primary',
            key: 'All'
        },
        {
            title: stats.active || 0,
            subtitle: 'Active',
            icon: 'ri:checkbox-circle-line',
            color: 'success',
            key: 'Active'
        },
        {
            title: stats.inactive || 0,
            subtitle: 'Inactive',
            icon: 'ri:close-circle-line',
            color: 'error',
            key: 'Inactive'
        },
        {
            title: stats.predefined || 0,
            subtitle: 'Predefined',
            icon: 'ri:shield-star-line',
            color: 'warning',
            key: 'Predefined'
        }
    ];

    const renderEventDetail = (item) => {
        return (
            <Box sx={{ p: 6, bgcolor: 'white', height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px' }}>
                    <div style={{ width: '45px', height: '45px', borderRadius: '10px', background: '#f0f7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Icon icon="ri:calendar-event-line" fontSize={24} color="#3b82f6" />
                    </div>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b' }}>
                        {item.EventName || 'Event Details'}
                    </Typography>
                </div>

                <Box sx={{ mb: 6, p: 4, borderRadius: '12px', border: '1px solid #f1f5f9' }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase' }}>Created By</Typography>
                            <Typography sx={{ fontWeight: 600, color: '#334155', mt: 0.5 }}>{item.CreatedBy || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase' }}>Created On</Typography>
                            <Typography sx={{ fontWeight: 600, color: '#334155', mt: 0.5 }}>{item.CreatedOn || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase' }}>Status</Typography>
                            <Box sx={{ mt: 0.5 }}>
                                <Chip
                                    label={item.IsActive ? 'ACTIVE' : 'INACTIVE'}
                                    size="small"
                                    sx={{
                                        bgcolor: item.IsActive ? '#ecfdf5' : '#fff1f2',
                                        color: item.IsActive ? '#10b981' : '#f43f5e',
                                        fontWeight: 700,
                                        fontSize: '11px'
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase' }}>Trigger Count</Typography>
                            <Typography sx={{ fontWeight: 600, color: '#334155', mt: 0.5 }}>
                                Success: {item.SuccessCount || 0} | Fail: {item.FailCount || 0}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#64748b', mb: 2, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Description
                </Typography>
                <Box sx={{
                    p: 4,
                    borderRadius: '12px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #f1f5f9',
                    minHeight: '150px'
                }}>
                    <Typography sx={{ color: '#475569', lineHeight: 1.6 }}>
                        {item.EventTemplate || 'No description provided for this event.'}
                    </Typography>
                </Box>
            </Box>
        );
    };

    if (!canView) {
        return (
            <Box sx={{ p: 0, display: 'flex', flexDirection: 'column', height: '100%', bgcolor: '#f1f5f9', position: 'relative' }}>
                <input type="hidden" id="hdnModuleCode" name="hdnModuleCode" value="PAG10333" readOnly />
                <PermissionDeniedComponent />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 0, display: 'flex', flexDirection: 'column', height: '100%', bgcolor: '#f1f5f9', position: 'relative' }}>
            <input type="hidden" id="hdnModuleCode" name="hdnModuleCode" value="PAG10333" readOnly />
            <SubHeader
                title="Event Configuration"
                searchQuery={searchTerm}
                setSearchQuery={setSearchTerm}
                pageName="Create Event"
                pageCode="PAG10333"
                searchPlaceholder="Search events..."
                onSearchClick={canSearch ? handleSearch : undefined}
                onAddClick={() => handlerAddEditCustomEvent({})}
                onRefreshClick={handleRefresh}
                showSettings={false}
                showViewSwitcher={true}
                viewMode={viewMode}
                setViewMode={setViewMode}
                showGrid={true}
                showTable={true}
                showAdd={canAdd}
                showSearch={canSearch}
                showRefresh={false}
                showCalendar={false}
            >
                <IconButton
                    onClick={handleShowAll}
                    title="Show All / Refresh"
                    sx={{
                        ml: 1,
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                        width: '40px',
                        height: '40px',
                        color: '#64748b',
                        '&:hover': { backgroundColor: '#f1f5f9' }
                    }}
                >
                    <Icon icon="ri:refresh-line" fontSize={20} />
                </IconButton>
            </SubHeader>

            {viewMode === 'table' ? (
                <PremiumModuleWrapper
                    moduleName="Event"
                    stats={stats}
                    showCards={true}
                    showTable={false} // We show our custom table in children
                    customCards={customCards}
                    onStatusClick={(status) => status === 'ResetAll' && handleShowAll()}
                    px="32px"
                >
                    <Box sx={{ p: 4, flex: 1, overflow: 'auto', bgcolor: '#f1f5f9' }}>
                        <Box sx={{ bgcolor: 'white', borderRadius: '16px', overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                            <table id="tblEventList" className="table table-striped table-bordered table-hover mb-0" style={{ width: '100%' }}>
                                <thead></thead>
                                <tbody></tbody>
                            </table>
                        </Box>
                    </Box>
                </PremiumModuleWrapper>
            ) : (
                <GridMainPanelLayout
                    type="event"
                    hideSidebarHeader={true}
                    showSelection={false}
                    data={tableData.map(item => ({
                        id: item.Id,
                        title: item.EventName,
                        name: item.CreatedBy,
                        date: item.CreatedOn,
                        status: item.IsActive ? 'Active' : 'Inactive',
                        _badgeText: item.IsActive ? 'ACTIVE' : 'INACTIVE',
                        _statusClass: item.IsActive ? 'completed' : 'overdue',
                        ...item
                    }))}
                    loading={false}
                    totalRecords={recordsTotal}
                    currentPage={currentPage}
                    totalPages={Math.ceil(recordsTotal / itemsPerPage)}
                    onPageChange={(page) => {
                        setCurrentPage(page);
                        if ($.fn.DataTable.isDataTable('#tblEventList')) {
                            $('#tblEventList').DataTable().page(page - 1).draw('page');
                        }
                    }}
                    selectedItem={selectedItem}
                    onSelectItem={setSelectedItem}
                    renderDetailContent={renderEventDetail}
                    formatDate={(d) => d}
                    getInitials={(n) => n ? n.charAt(0).toUpperCase() : 'E'}
                />
            )}

            {showForm && (
                <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, bgcolor: '#eee' }}>
                    <CreateEventForm onSuccess={() => { setShowForm(false); $('#tblEventList').DataTable().ajax.reload(); }} />
                </Box>
            )}
        </Box>
    );
};

export default CreateEventWrapper;
